<template>
    <div>
        <a-row :gutter="16" gr>
                <a-col  :xs="{span: 24}" :lg="{span: 12}">
                    <a-card title="ยอดรวมเติมเงิน ผู้ให้บริการ" :bordered="true">
                      <a-descriptions title="" layout="vertical" bordered>
                        <a-descriptions-item v-for="(item , index) in dataDeposit" :key="index" :label="item.providerName">
                          {{ item.depositUserSBOAmount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') }}
                        </a-descriptions-item>
                      </a-descriptions>
                    </a-card>
                </a-col>
                <a-col  :xs="{span: 24}" :lg="{span: 12}">
                    <a-card title="ยอดรวมการถอนเงิน ผู้ให้บริการ" :bordered="true">
                      <a-descriptions title="" layout="vertical" bordered>
                        <a-descriptions-item v-for="(item , index) in dataWithdrew" :key="index" :label="item.providerName">
                          {{ item.withdrawUserSBOAmount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') }}
                        </a-descriptions-item>
                      </a-descriptions>
                    </a-card>
                </a-col>
            </a-row>
    </div>
</template>
<script>

import { mapGetters } from 'vuex'
import apiClient from '@/services/api'
// import moment from 'moment'
import Swal from 'sweetalert2'
// import axios from 'axios'
// const Toast = Swal.mixin({
//   toast: true,
//   position: 'top-end',
//   showConfirmButton: false,
//   timer: 3000,
//   timerProgressBar: true,
//   didOpen: (toast) => {
//     toast.addEventListener('mouseenter', Swal.stopTimer)
//     toast.addEventListener('mouseleave', Swal.resumeTimer)
//   },
// })
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
  },
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getProviderId: 'getProviderId',
    }),
    myVal() {
      if (this.ctr === 0) {
        this.reCountdown()
      }
      return this.ctr
    },
  },
  watch: {
    getStartDate: function(val) {
      if (val) this.getDataDeposiit()
    },
    getEndDate: function(val) {
      if (val && !this.checkFistPage) {
        this.getDataDeposiit()
      }

      if (this.checkFistPage) this.checkFistPage = false
    },
    getProviderId: function(val) {
      if (val) this.getDataDeposiit()
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
  },

  data() {
    return {
      isLoading: false,
      refresh: false,
      countdown: false,
      timer: '',
      counters: '',
      counters2: '',
      ctr: 5,
      dataDeposit: [],
      dataWithdrew: [],
    }
  },
  methods: {
    async getDataDeposiit() {
      const dataDeposit = await {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        providerId: this.getProviderId,
      }
      await apiClient.post('/depositUserSBO/getSumDataMember', dataDeposit).then(response => {
        if (response.data.code === '000') {
          this.dataDeposit = response.data.responseData.data.dataSumDeposit
          this.dataWithdrew = response.data.responseData.data.dataSumWithdraw
        }
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    getAutoRefresh(refresh) {
      if (!refresh) {
        this.refresh = true
        this.ReloadData(true)
      } else {
        this.refresh = false
        this.ReloadData(false)
      }
    },
    ReloadData (value) {
      if (value) {
        this.countdown = true
        this.counters = setInterval(function () {
          this.getDataDeposiit()
        }.bind(this), 5000)
        this.counters2 = setInterval(function () {
          this.ctr = this.ctr - 1
        }.bind(this), 1000)
      } else {
        clearInterval(this.counters)
        clearInterval(this.counters2)
        this.ctr = 5
      }
    },
    reCountdown () {
      this.ctr = 5
    },
  },
  async created() {
    // await this.getDataWithdraw()
  },
}
</script>

  <style>

  </style>
